/**
 * Color Picker for Chrome™
 *
 * Declares seven web-accessible resources on `<all_urls>` with no `use_dynamic_url` —
 * `canvas.css`, `plus.png`, `copy.png`, `cp.png`, `logo.svg`, `pickicon.svg` and
 * `logoNew.svg`. Each is served at a fixed URL to any page. The vendor-named
 * `pickicon.svg` and `logoNew.svg` are the cleanest signals; being images they load
 * through `probeImage` with no CORS grant.
 *
 * Manifest verified against version 3.0.1.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'clldacgmdnnanihiibdgemajcfkmfhia';

export const colorPicker: ExtensionDefinition = {
  id: ID,
  name: 'Color Picker for Chrome™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'Seven static WAR on <all_urls> with no dynamic URL. The vendor-named pickicon.svg ' +
    'loads via <img> without a CORS grant, so detection is conclusive and CSP-proof.',
  signals: [
    {
      id: 'war-pickicon-svg',
      kind: 'web-accessible-resource',
      description:
        'Load pickicon.svg via <img> — the vendor-named picker icon exposed to every ' +
        'origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'pickicon.svg'),
    },
    {
      id: 'war-logo-new-svg',
      kind: 'web-accessible-resource',
      description:
        'Load logoNew.svg via <img> — a second vendor-named branding asset that ' +
        'corroborates the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'logoNew.svg'),
    },
    {
      id: 'war-canvas-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch canvas.css — the picker-overlay stylesheet, an independent third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'canvas.css'),
    },
  ],
};
